module.exports = __webpack_public_path__ + "static/media/VIVOpago-logo-white text.e4aaee88.svg";